// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import '../src/image.js'
import '../src/common';
import '../stylesheets/common';

var buildCountdown = require('../src/countdown/');
window.$.fn.buildCountdown = buildCountdown.default;
var buildNeighbourhoodMap = require('../src/neighbourhood_map/');
window.$.fn.buildNeighbourhoodMap = buildNeighbourhoodMap.default;

var buildJustifiedGallery = require('../src/justified_gallery/');
window.$.fn.buildJustifiedGallery = buildJustifiedGallery.default;

var buildPhoneCode = require('../src/phone_code/');
window.$.fn.buildPhoneCode = buildPhoneCode.default;

var buildTunnel = require('../src/tunnel/');
window.$.fn.buildTunnel = buildTunnel.default;

var buildFlipbook = require('../src/flipbook/');
window.$.fn.buildFlipbook = buildFlipbook.default;

var buildAppointmentCalendar = require('../src/appointment_calendar/');
window.$.fn.buildAppointmentCalendar = buildAppointmentCalendar.default;

var openNavigationTooltip = require('../src/navigation_tooltips');
window.openNavigationTooltip = openNavigationTooltip.default;

var buildBudgetInput = require('../src/budget_input/');
window.$.fn.buildBudgetInput = buildBudgetInput.default;

var buildSuperadminJumperForm = require('../src/superadmin_jumper_form');
window.$.fn.buildSuperadminJumperForm = buildSuperadminJumperForm.default;

var buildYouSignHandler = require('../src/yousign_handler');
window.$.fn.buildYouSignHandler = buildYouSignHandler.default;

var buildFintectureHandler = require('../src/fintecture_handler');
window.$.fn.buildFintectureHandler = buildFintectureHandler.default;

var buildFintecturePaymentHandler = require('../src/fintecture_payment_handler');
window.$.fn.buildFintecturePaymentHandler = buildFintecturePaymentHandler.default;

var buildReservationForm = require('../src/reservation_form');
window.$.fn.buildReservationForm = buildReservationForm.default;
